import type { ButtonProps } from '../primitives/button.js'
import type { BaseLayoutSpec } from '@tunasong/plugin-lib'
import type { FC } from 'react'
import { MenuButtonSelector } from '../menu/menu-button.js'

export interface LayoutSelectorProps extends Omit<ButtonProps, 'onChange'> {
  layouts: BaseLayoutSpec[]
  selected?: BaseLayoutSpec
  /** Show the selected layout's icon before its name. Default true. */
  showIcon?: boolean
  onChange(layout: BaseLayoutSpec): void
}

export const LayoutSelector: FC<LayoutSelectorProps> = props => {
  const { layouts, selected, onChange, ...restProps } = props

  return <MenuButtonSelector items={layouts} onChange={onChange} selected={selected} {...restProps} />
}

export default LayoutSelector
